import * as React from 'react';
import RcSelect__default, { Option, OptGroup } from 'rc-select';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { Id } from '../../utils/ids.js';
import { Bem, addClass } from '../../utils/css.js';
import { Size } from '../../constants.js';
import './Select.scss.js';
import { Icon } from '../Icon/Icon.js';

const bem = Bem.create("vai-select");
class Select extends React.Component {
  constructor() {
    super(...arguments);
    this.ref = React.createRef();
    this.saveSelect = (node) => {
      this.rcSelect = node;
    };
    this.getPopupContainer = () => {
      return this.ref.current;
    };
  }
  render() {
    const {
      htmlId,
      invalid,
      dataTa,
      width,
      mode,
      prefixCls,
      optionLabelProp,
      className,
      selectDivTitle,
      removeIcon,
      clearIcon,
      inputIcon,
      menuItemSelectedIcon,
      dropdownClassName,
      showArrow,
      ...rest
    } = this.props;
    const id = Id.create(htmlId, ["select"]);
    const removeChoiceIcon = removeIcon ? removeIcon : /* @__PURE__ */ React.createElement(Icon, {
      name: VaiIcon.Cross,
      className: `${prefixCls}-remove-icon`
    });
    const clearChoiceIcon = clearIcon ? clearIcon : /* @__PURE__ */ React.createElement(Icon, {
      name: VaiIcon.Cross,
      className: `${prefixCls}-remove-icon`
    });
    const suffixIcon = inputIcon ? inputIcon : /* @__PURE__ */ React.createElement(Icon, {
      name: VaiIcon.ChevronDown,
      className: `${prefixCls}-arrow-icon`
    });
    const itemSelectedIcon = menuItemSelectedIcon ? menuItemSelectedIcon : /* @__PURE__ */ React.createElement(Icon, {
      name: VaiIcon.Check,
      className: `${prefixCls}-selected-icon`
    });
    const outerClass = this.getClassName(true, bem.block(invalid && "error", width), className);
    const innerClass = this.getClassName(false, bem.element("rc-select")(), className);
    const selectDropdownClassName = addClass(bem.element("dropdown")(mode), mode ? bem.element(`dropdown--multiple`)() : bem.element(`dropdown--single`)(), dropdownClassName);
    return /* @__PURE__ */ React.createElement("div", {
      id: id.toString(),
      "data-ta": dataTa,
      className: outerClass,
      ref: this.ref,
      title: selectDivTitle
    }, /* @__PURE__ */ React.createElement(RcSelect__default, {
      className: innerClass,
      getPopupContainer: this.getPopupContainer,
      inputIcon: suffixIcon,
      removeIcon: removeChoiceIcon,
      clearIcon: clearChoiceIcon,
      menuItemSelectedIcon: itemSelectedIcon,
      optionLabelProp,
      dropdownAlign: { offset: [0, -1] },
      mode,
      dropdownClassName: selectDropdownClassName,
      showArrow,
      ...rest,
      ref: this.saveSelect
    }));
  }
  getClassName(outer, defaultClassName, additionalClassName) {
    let additionalClass = "";
    if (Array.isArray(additionalClassName)) {
      if (outer && additionalClassName[0]) {
        additionalClass = additionalClassName[0];
      } else if (additionalClassName[1]) {
        additionalClass = additionalClassName[1];
      }
    } else if (additionalClassName) {
      additionalClass = additionalClassName;
    }
    return addClass(defaultClassName, additionalClass);
  }
  focus() {
    this.rcSelect.focus();
  }
  blur() {
    this.rcSelect.blur();
  }
}
Select.defaultProps = {
  width: Size.M,
  prefixCls: "rc",
  autoFocus: false,
  optionLabelProp: "children",
  showArrow: true
};
Select.Option = Option;
Select.OptGroup = OptGroup;
Select.metaProperties = ["invalid", "disabled"];

export { Select };
